import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  IconButton,
  Chip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import { TableContent, HeaderAccordion } from "../styles/Fornecedor";
import TableDefault from "../../../../components/grid/TableDefault";
import { FornecedorContext } from "../contexts/FornecedorContext";
import MaskService from "../../../../utils/mask/maskService";
import useFornecedorController from "../controllers/FornecedorController";
import ModalFornecedorContato from "./ModalFornecedorContato";

import { IconButtonStyled } from "../styles/Fornecedor";

import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { DeleteOutlined } from "@material-ui/icons";

export default function AccordionFonecedorContato() {
  const {
    //Contato
    expanded,
    contacts,
    setContacts,
    geralErrors,
  } = useContext(FornecedorContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useFornecedorController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const { handleDeleteSupplierContact } = useFornecedorController();

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlinedIcon />,
                name: "Editar",
                action: () => {
                  setRowEdit(item);
                  setOpen(true);
                },
              },
              {
                icon: <DeleteOutlined />,
                name: "Excluir",
                action: () => handleDeleteSupplierContact(item.id),
              },
            ]}
          />
        );
      },
    },
    {
      id: "nome",
      label: "Nome",
    },
    {
      id: "email",
      label: "E-mail",
    },

    {
      id: "telefone",
      label: "Telefone",
    },
    {
      id: "dpto",
      label: "Departamento",
    },
    {
      id: "cep",
      label: "CEP",
    },
    {
      id: "endereco",
      label: "Endereço",
    },
    {
      id: "numero",
      label: "Número",
      align: "center",
    },
  ];

  useEffect(() => {
    (async () => {
      const newList = [];
      contacts.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            contatoTel: MaskService.toMask("cel-phone", item.contatoTel || ""),
            contatoCep: MaskService.toMask("cep", item.contatoCep || ""),
            acoes: (
              <div>
                <Tooltip title="Editar">
                  <IconButton>
                    <EditOutlinedIcon
                      onClick={() =>
                        handleEditItemTable(setOpen, setRowEdit, item, index)
                      }
                    />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Deletar">
                  <IconButton>
                    <DeleteOutlineOutlinedIcon
                      onClick={() =>
                        handleRemoveItemTable(
                          setContacts,
                          setDataTable,
                          contacts,
                          index
                        )
                      }
                    />
                  </IconButton>
                </Tooltip>
              </div>
            ),
          })
      );
      setDataTable(newList);
    })();
    // eslint-disable-next-line
  }, [contacts]);

  return (
    <>
      {open && (
        <ModalFornecedorContato
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
        />
      )}
      <Grid item>
        <Accordion
          expanded={expanded.contacts || false}
          onChange={() => handleChangeOpenAcordion("contacts")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                  <Chip
                    bgcolor={
                      !expanded.general &&
                      geralErrors.accordions &&
                      geralErrors.accordions.includes("contacts")
                        ? "red"
                        : "primary"
                    }
                    textcolor="white"
                    label="CONTATOS"
                  />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Contatos">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        loading={false}
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
